import Translations from "translations/types";

const REHAB_FORM_TOUR_STEPS = {
  ELIGIBILITY_TAB: "eligibility_tab",
  SEND_DOCUMENTS_HEADING: "send_documents_heading",
  FILL_IN_GKV_GENERAL_FORM: "fill_in_gkv_general_form",
  FILL_IN_GKV_MEDICAL_FORM: "fill_in_gkv_medical_form",
  SEND_DOCUMENTS_BUTTON: "send_documents_button",
  REPLY_SECTION: "reply_section",
} as const;

export const REHAB_FORMS_TOUR = {
  key: "dta",
  steps: {
    [REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_HEADING]: {
      key: REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_HEADING,
      title: (t: Translations) => t.tours.dta.stepB.title,
      intro: (t: Translations) => t.tours.dta.stepB.intro,
      step: 1,
    },
    [REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_GENERAL_FORM]: {
      key: REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_GENERAL_FORM,
      title: (t: Translations) => t.tours.dta.stepC.title,
      intro: (t: Translations) => t.tours.dta.stepC.intro,
      step: 2,
    },
    [REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_MEDICAL_FORM]: {
      key: REHAB_FORM_TOUR_STEPS.FILL_IN_GKV_MEDICAL_FORM,
      title: (t: Translations) => t.tours.dta.stepD.title,
      intro: (t: Translations) => t.tours.dta.stepD.intro,
      step: 3,
    },
    [REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_BUTTON]: {
      key: REHAB_FORM_TOUR_STEPS.SEND_DOCUMENTS_BUTTON,
      title: (t: Translations) => t.tours.dta.stepE.title,
      intro: (t: Translations) => t.tours.dta.stepE.intro,
      step: 4,
    },
    [REHAB_FORM_TOUR_STEPS.REPLY_SECTION]: {
      key: REHAB_FORM_TOUR_STEPS.REPLY_SECTION,
      title: (t: Translations) => t.tours.dta.stepF.title,
      intro: (t: Translations) => t.tours.dta.stepF.intro,
      step: 5,
    },
  },
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  disablePageScroll: true,
} as const;
